/* eslint-disable */
import createIcon from '../createIcon';

const IconSort = createIcon({
  name: 'icon-sort',
  content: '<title>ic_排序</title><defs><rect id="icon-sort-a" x="0" y="0" width="16" height="16"/></defs><g stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-959.000000, -6456.000000)"><g transform="translate(498.000000, 6169.000000)"><g transform="translate(111.000000, 287.000000)"><g transform="translate(350.000000, 0.000000)"><mask id="icon-sort-b" fill="currentColor"><use xlink:href="#icon-sort-a"/></mask><use fill="currentColor" opacity="0" xlink:href="#icon-sort-a"/><path d="M4.94318932,6 L11.0568107,6 L8,1.72046505 L4.94318932,6 Z M8,0 L13,7 L3,7 L8,0 Z M11.0568107,10 L4.94318932,10 L8,14.2795349 L11.0568107,10 Z M8,16 L3,9 L13,9 L8,16 Z" fill="currentColor" fill-rule="nonzero" mask="url(#icon-sort-b)"/></g></g></g></g></g>',
  width: 16,
  height: 16
}, 'Icon');
export default IconSort;
